import { GameUIConfig } from "../GameConfig/GameConfig.js";
import { PickupAbility, PickupConfig } from "../GameConfig/PickupConfig.js";

export default class PickUpUI {
  constructor() {
    this.image = new Image();
    this.image.src = "";

    this.x = GameUIConfig.ImageUI.X;
    this.y = GameUIConfig.ImageUI.Y;

    this.spriteWidth = GameUIConfig.ImageUI.SPRITE_WIDTH;
    this.spriteHeight = GameUIConfig.ImageUI.SPRITE_HEIGHT;
  }

  draw(context) {
    context.drawImage(
      this.image,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );
  }

  update(playerAbility) {
    this.image.src = "";
    if (playerAbility.has(PickupAbility.SHIELD)) {
      this.image.src = PickupConfig.Shield.IMG_SRC;
    }
    // add other pickup abilities
    if (playerAbility.has(PickupAbility.TURRET)) {
      this.image.src = PickupConfig.Turret.IMG_SRC;
    }
  }
}
